module.exports = __webpack_public_path__ + "static/media/plus.d0e1333d.svg";